import {
    FeatureFlagKey,
    FeatureFlag,
    FeatureFlagIdentifyInfo,
    FeatureFlagEvent,
    FeatureFlagSourceName,
} from '../types';

enum ConnectStatus {
    PENDING,
    SUCCESS,
    FAILED,
}
interface FeatureFlagController {
    sourceName: FeatureFlagSourceName;
    isReady: boolean;
    isPending: boolean;
    isFailed: boolean;
    getFeatureFlag(type: FeatureFlagKey): FeatureFlag;
    getFeatureFlagOriginKey(type: FeatureFlagKey): string;
    isFlagSupported(type: FeatureFlagKey): boolean;
    identify(identifyInfo: FeatureFlagIdentifyInfo): void;
    on(event: FeatureFlagEvent, listener: (...args: Array<unknown>) => void): () => void;
    once(event: FeatureFlagEvent, listener: (...args: Array<unknown>) => void): void;
    removeListener(event: FeatureFlagEvent, cb: (...args: Array<unknown>) => void): void;
    removeAllListeners(): void;
    emit(event: FeatureFlagEvent, ...args: Array<unknown>): void;
}

export { ConnectStatus, FeatureFlagController };
